export default __webpack_public_path__ + "static/media/team67.0aad3fe2.JPG";